export default __webpack_public_path__ + "static/media/virusred-250-4-min.6d06f0db.png";